import React from 'react'
import { Link } from 'react-router-dom'
import { useContent } from '../../services'

const featureImages = {
  'featured-1.jpg': require('../../assets/images/resource/featured-1.jpg'),
  'featured-2.jpg': require('../../assets/images/resource/featured-2.jpg'),
  'featured-3.jpg': require('../../assets/images/resource/featured-3.jpg'),
};

function Feature() {
    const { data: features, loading } = useContent('homeFeatures');

    if (loading || !features) return null;

    return (
        <>
            <section className="featured-links">
                <div className="outer-container">
                    <div className="row clearfix">
                        {features.map((feature, index) => {
                            const img = featureImages[feature.image];
                            const isAlternate = index === 1;
                            return (
                                <div key={feature.id} className={`link-block ${isAlternate ? 'alternate ' : ''}col-xl-4 col-lg-4 col-md-${index === 2 ? '12' : '6'} col-sm-12`}>
                                    <div className="inner wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                                        {(!isAlternate) && (
                                            <div className="text-block">
                                                <div className="bl-inner">
                                                    <div className="content">
                                                        <div className="subtitle">{feature.subtitle}</div>
                                                        <h3>{feature.title}</h3>
                                                        <div className="text" style={{ color: 'var(--main-color)' }}>{feature.text}</div>
                                                        <div className="link">
                                                            <Link to={feature.cta.link} className="theme-btn">
                                                                <span>{feature.cta.label}</span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="image-box">
                                            <div className="image-layer" style={{ backgroundImage: `url(${img})` }} />
                                            <div className="image">
                                                <img src={img} alt="" />
                                            </div>
                                        </div>
                                        {isAlternate && (
                                            <div className="text-block">
                                                <div className="bl-inner">
                                                    <div className="content">
                                                        <div className="subtitle">{feature.subtitle}</div>
                                                        <h3>{feature.title}</h3>
                                                        <div className="text" style={{ color: 'var(--main-color)' }}>{feature.text}</div>
                                                        <div className="link">
                                                            <Link to={feature.cta.link} className="theme-btn">
                                                                <span>{feature.cta.label}</span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Feature
